// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__hU2Sf","dragIcon":"SortableItem_dragIcon__KNCeY","disabled":"SortableItem_disabled__1Pdn0"};